<template>
  <div class="range__container" >
    <div :class="{'range-containers':items>1}">
       <div class="contents-rangers" v-if="rangeFilterPrice">
      <h2 class="center-text range__container-title">
        Filtrar Precio de Terreno
      </h2>
      <div class="range__container-item range-price-container" >
        <div class="range-numbers range-numbers-left">
          {{ formatValue(returnMinPrice) }}
        </div>
        <div class="range-buttons range-buttons-price">
          <vue-slider
            class="rangeprice-custom range-price-custom"
            :tooltip-formatter="(val) => formatValue(val)"
            v-model="rangePrice"
            :min="returnMinPrice"
            :max="returnMaxPrice"
            @change="changeRange"
            :enable-cross="false"
          >
          </vue-slider>
        </div>
        <div class="range-numbers range-numbers-right">
          {{ formatValue(returnMaxPrice) }}
        </div>
      </div>
    </div>

    <div class="contents-rangers">
      <h2 class="center-text range__container-title">
        Filtrar por M <sup>2</sup> de Terreno
      </h2>
      <div class="range__container-item ">
        <div class="range-numbers range-numbers-left">{{ returnMin }}</div>
        <div class="range-buttons">
          <vue-slider
            class="rangeprice-custom"
            v-model="range"
            :min="returnMin"
            :max="returnMax"
            @change="changeRange"
            :enable-cross="false"
          ></vue-slider>
        </div>
        <div class="range-numbers range-numbers-right">{{ returnMax }}</div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: {
    VueSlider,
  },
  props: ["locations", "rangeFilter", "rangeFilterPrice"],
  data() {
    return {
      value_2: [106, 167],
      range: "",
      rangePrice: "",
      items:null
    };
  },
  computed: {
    returnMin() {
      return Number(this.rangeFilter[0]);
    },
    returnMax() {
      return Number(this.rangeFilter[1]);
    },
    returnMinPrice() {
      if (this.rangeFilterPrice) {
        return Number(this.rangeFilterPrice[0]);
      } else {
        return false;
      }
    },
    returnMaxPrice() {
      if (this.rangeFilterPrice) {
        return Number(this.rangeFilterPrice[1]);
      } else {
        return false;
      }
    },
    filterLocations: function () {
      if (this.range === "") {
        return this.locations;
      } else {
        return this.filterLocationsByRange(this.locations);
      }
    },
  },
  methods: {
    showItems(){
      if(this.rangeFilter && this.rangeFilterPrice){
        this.items=2
      }else{
        this.items=1
      }
    },
    formatValue(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    changeRange() {
      this.$emit("change", this.filterLocations);
    },
    filterLocationsByRange: function (locations) {
      /* if (this.range === "all") {
        return locations;
      } else { */ 
      let arrModel;
      if (this.rangeFilter && this.rangeFilterPrice) {
          let unav = locations.filter((i) => i.status!=2 )
          let avail = locations.filter((location) =>
          location.status==2 && 
          location.m2t >= this.range[0] &&
          location.m2t <= this.range[1] &&
          location.value >= this.rangePrice[0] &&
          location.value <= this.rangePrice[1]
            ? location
            : ""
        );
        arrModel = unav.concat(avail)
        return arrModel;
      } else if (this.rangePrice && !this.rangeFilterPrice) {
        let unav = locations.filter((i) =>  i.status!=2)
        let avail = locations.filter((location) =>
          location.status==2 &&
          location.m2t >= this.range[0] && location.m2t <= this.range[1]
            ? location
            : ""
        );
        arrModel = unav.concat(avail)
        return arrModel;
      }
      /*  */
      //}
    },
  },
  mounted() {
    this.changeRange();
    this.range = [this.returnMin, this.returnMax];
    this.rangePrice = [this.returnMinPrice, this.returnMaxPrice];
    this.showItems();
  },
};
</script>
<style >
.rangeprice-custom .vue-slider-dot-handle {
  background: #152541;
}
.rangeprice-custom .vue-slider-process {
  background: #152541;
}
.rangeprice-custom .vue-slider-dot-tooltip-inner {
  background: #152541;
  border-color: #152541;
}
</style>
<style scoped>
.range__container-item {
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin-top: 2rem;
}
.range-numbers {
  font-size: 1.4rem;
 /*  min-width: 40px; */
  padding: 0 20px;
  /* width: 25%; */
  font-weight: 700;
}

.range-buttons {
  width: 100%;
  max-width: 300px;
}

.range-numbers-left {
  text-align: right;
}
.range-numbers-right {
  text-align: left;
}

@media (min-width:1201px) {
  .range-containers{
    display:flex;
  }
  .range-containers .contents-rangers{
    width: 100%;
  }
  .range__container{
    margin-bottom:5rem;
    margin-top:2rem
  }
  .range-containers{
    display: flex;
  flex-direction: column-reverse;
  }
  .range__container-title {
    margin-top: 2rem;
    font-size: 1.8rem;
  }
}
@media (max-width:1200px) {
  .range-containers{
    display: flex;
  flex-direction: column-reverse;
  }
  .contents-rangers{
    margin-bottom:1.7rem;
  }
  .range__container-title {
    margin-top: 2rem;
    font-size: 2.3rem;
  }
}


@media (max-width: 767.67px) {
  .range__container-title {
    font-size: 2rem;
  }
}
@media (max-width:550px) {
  .range-price-custom.vue-slider{
    width:90%!important;
  }
  .range-buttons-price{
    display: flex;
  justify-content: center;
  }
  .range-price-container .range-numbers-right{
    padding:0 1px
  }
  .range-price-container .range-numbers-left{
    padding:0 1px
  }
}
@media (max-width:550px) {
  .range-price-custom.vue-slider{
    width:80%!important;
  }
  .range-buttons-price{
    display: flex;
  justify-content: center; width: 65%;
  }
  

  .range-price-container .range-numbers-left{
    padding:0 1px
  }
}
@media (max-width:415px) {
  .range-price-container .range-numbers{
    font-size: 1.2rem;
  }
}
@media (max-width:360px) {
.range-buttons-price{
    width: 65%;
  }
}
</style>
